import { render, staticRenderFns } from "./PopUpServices.vue?vue&type=template&id=c74acd02&scoped=true&"
import script from "./PopUpServices.vue?vue&type=script&lang=js&"
export * from "./PopUpServices.vue?vue&type=script&lang=js&"
import style0 from "./PopUpServices.vue?vue&type=style&index=0&id=c74acd02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74acd02",
  null
  
)

export default component.exports